import React from 'react';
import GridFunctions from '../../../../Services/agGrid/ag-Grid-functions';
import GridCheckBox from '../../../../Components/Ui/GridCheckBox/GridCheckBox';

export const getColumnDefs1 = () => [
  {
    headerCheckboxSelection: false,
    field: 'no',
    headerName: 'NO',
    maxWidth: 100,
    cellStyle: {
      textAlign: 'right',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    editable: false,
  },
  {
    field: 'PL_TYPE',
    headerName: '구분 코드',
    minWidth: 150,
    flex: 1,
    editable: false,
    hide: false,
  },
  {
    field: 'PL_TYPE_NM',
    headerName: '구분 명',
    minWidth: 150,
    flex: 1,
    editable: false,
    hide: false,
  },
];

export const getColumnDefs2 = (props) => [
  {
    headerCheckboxSelection: true,
    field: 'no',
    headerName: 'NO',
    maxWidth: 100,
    cellStyle: {
      textAlign: 'right',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    editable: false,
    cellClass: 'delete-action-cell',
    cellRenderer: (params) => (
      <GridCheckBox
        params={params}
        DeleteNewRow={props.DeleteNewRow2}
        RestoreRow={props.RestoreRow2}
        gridRef={props.gridRef2}
        rowData={props.rowData2}
        selectedRowNosRef={props.selectedRowNosRef2}
        lastCheckedIndexRef={props.lastCheckedIndexRef2}
        handleRowSelection={props.handleRowSelection2}
      />
    ),
  },
  {
    field: 'PL_TYPE',
    headerName: '구분코드',
    minWidth: 100,
    editable: false,
    hide: true,
  },
  {
    field: 'PRO_ID',
    headerName: '프로그램ID',
    minWidth: 250,
    editable: (params) => GridFunctions.isCellEditable(params),
  },
  {
    field: 'PRO_CONTENT',
    headerName: '프로그램 설명',
    minWidth: 250,
    flex: 1,
    editable: false,
  },
];

export const getColumnDefs3 = (props) => [
  {
    headerCheckboxSelection: true,
    field: 'no',
    headerName: 'NO',
    maxWidth: 100,
    cellStyle: {
      textAlign: 'right',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    editable: false,
    cellClass: 'delete-action-cell',
    cellRenderer: (params) => (
      <GridCheckBox
        params={params}
        gridRef={props.gridRef3}
        rowData={props.modalRowData1}
        selectedRowNosRef={props.selectedRowNosRef3}
        lastCheckedIndexRef={props.lastCheckedIndexRef3}
        handleRowSelection={props.handleRowSelection3}
      />
    ),
  },
  {
    field: 'PRO_ID',
    headerName: '프로그램ID',
    minWidth: 250,
    editable: (params) => GridFunctions.isCellEditable(params),
  },
  {
    field: 'PRO_CONTENT',
    headerName: '프로그램 설명',
    minWidth: 250,
    flex: 1,
    editable: false,
  },
];
